import $ from 'jquery';

$(function () {
    $('.app-registration-user-type').on('change', function () {
        $('.app-registration-user-type-wrapper').removeClass('active');
        if ($(this).is(':checked')) {
            $(this).closest('.app-registration-user-type-wrapper').addClass('active');
        }
    });
})
